import React from 'react';
import { PropsWithChildren } from 'src/PropsWithChildren';

export interface ITabPanelProps extends PropsWithChildren {
  tab: string;
  value: string;
  className?: string;
}

/** @registry Renders its children only while `value === tab`, keeping the panel in the DOM (hidden) otherwise — for use alongside Mantine Tabs. */
export const TabPanel: React.FC<ITabPanelProps> = ({
  children,
  tab,
  value,
  className = 'p-20',
}) => {
  return (
    <div
      role="tabpanel"
      className={className}
      style={{ height: '100%' }}
      hidden={value !== tab}
    >
      {value === tab && <>{children}</>}
    </div>
  );
};
